import React from 'react';
import '../template-file-css/document-file-template.css';


export const NP_MonthlySummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NP_MonthlySummary' className='file-pdf-document'>
            <div className='file-template'>


                <p>
                    <span className='eleHeader'>A.  NARRATIVE SUMMARY:</span>
                    <span className='small'>(Instructions: Please provide a brief summary of client's progress (or lack of progress) towards goals including family interactions)</span>
                    <textarea id='txtNarrativeSummary' name='txtNarrativeSummary' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>B. NEXT STEPS:</span>
                    <span className='small'>(Instructions: Please provide a brief summary of any additional needs, recommendations, community linkages and new goals of treatment and thoroughly detail the next steps.)</span>
                    <textarea id='txtNextSteps' name='txtNextSteps' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Demographics </span>
                            <span className='small'>(Pls check all that applies)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-230'> <input type='checkbox' id='cbDemographics_1' name='cbDemographics_1' className='add-only' value='Demographics_1' /> DJJ Involvement </td>
                        <td className='w-230'> <input type='checkbox' id='cbDemographics_2' name='cbDemographics_2' className='add-only' value='Demographics_2' /> PRTF </td>
                        <td className='w-290'> <input type='checkbox' id='cbDemographics_3' name='cbDemographics_3' className='add-only' value='Demographics_3' /> Probation Violation/Court Retention </td>
                    </tr>
                    <tr>
                        <td className='w-230'> <input type='checkbox' id='cbDemographics_4' name='cbDemographics_4' className='add-only' value='Demographics_4' /> Crisis Call </td>
                        <td className='w-230'> <input type='checkbox' id='cbDemographics_5' name='cbDemographics_5' className='add-only' value='Demographics_5' /> Elopement/Wandering </td>
                        <td className='w-290'> <input type='checkbox' id='cbDemographics_6' name='cbDemographics_6' className='add-only' value='Demographics_6' /> DFCS Report Made </td>
                    </tr>
                    <tr>
                        <td className='w-230'> <input type='checkbox' id='cbDemographics_7' name='cbDemographics_7' className='add-only' value='Demographics_7' /> Court Appearance </td>
                        <td className='w-230'> <input type='checkbox' id='cbDemographics_8' name='cbDemographics_8' className='add-only' value='Demographics_8' /> Critical Incident  </td>
                        <td className='w-290'> <input type='checkbox' id='cbDemographics_9' name='cbDemographics_9' className='add-only' value='Demographics_9' /> Hospitalized </td>
                    </tr>
                    <tr>
                        <td className='w-230'> <input type='checkbox' id='cbDemographics_10' name='cbDemographics_10' className='add-only' value='Demographics_10' /> DFCS Involvement </td>
                    </tr>
                    <tr>
                        <td className='w-230'>
                            <input type='checkbox' id='cbDemographics_11' name='cbDemographics_11' className='add-only' value='Demographics_11' /> OTHER (Pls specify):
                            <input type='text' id='txtOtherDemographics_11' name='txtOtherDemographics_11' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>BY:</strong>
                    (Please include credentials after your name)
                </p>


                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Clinician Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Clinician  Print Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p>
                    <strong>REVIEWED BY (If Applicable):</strong>
                    (Please include credentials after your name)
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Supervisor/Reviewer Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Supervisor/Reviewer Print Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}